import router from 'views/pro/clientes/panel-cliente/router';
import App from 'views/pro/clientes/panel-cliente/App.vue';
import store from 'views/pro/clientes/panel-cliente/store';
import numeral from 'numeral';
import moment from 'moment';
import modalCalificaciones from 'views/pro/clientes/modal_calificaciones.vue';
import type { Route } from 'vue-router';

import 'moment/locale/es';

const Vue = window.Vue;

// ── Globales del dominio ──────────────────────────────────────────────────────
Vue.prototype.base_url = base_url;
Vue.prototype.numeral = numeral;
Vue.prototype.moment = moment;

// ── Registro global de componentes compartidos ────────────────────────────────
Vue.component('ModalCalificaciones', modalCalificaciones);

// ── Inicialización de la SPA ──────────────────────────────────────────────────
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  beforeCreate() {
    router.onReady((ruta: Route) => {
      this.inicializarContextoDesdeRuta(ruta);
    });
  },
  methods: {
    inicializarContextoDesdeRuta(ruta: Route): void {
      const idMm = ruta.params.id_mm;
      const token = ruta.query.t as string | undefined;

      if (!idMm || !token) return;

      this.$store.commit('SET_CONTEXTO_CLIENTE', { id_mm: idMm, token });
    },
  },
});
